import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11d3a3e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row justify--center" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card receipt-section" }
const _hoisted_5 = { class: "card-header justify--center ma--y-2" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "card-content ma-2"
}
const _hoisted_8 = { class: "text--align-center" }
const _hoisted_9 = { class: "display--flex justify--space-between align--flex-start" }
const _hoisted_10 = { class: "invoice__address" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Bill To", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { class: "invoice__meta" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Receipt #:", -1))
const _hoisted_18 = { class: "table table--striped ma--top-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "DESCRIPTION"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "QTY"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-right" }, "AMOUNT")
  ])
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text--align-left" }, "Credits", -1))
const _hoisted_21 = { class: "text--align-left" }
const _hoisted_22 = { class: "text--align-right" }
const _hoisted_23 = {
  colspan: "5",
  class: "text--align-right"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invoice__footer" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Please Quote Invoice Number in all correspondence"),
  /*#__PURE__*/_createElementVNode("h4", null, "Thank You For Your Business!")
], -1))
const _hoisted_25 = { class: "card-footer text--align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.logo,
              class: "login-logo",
              alt: "Lead Pulse"
            }, null, 8, _hoisted_6)
          ]),
          (_ctx.credit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.isSubscriptionCredits(_ctx.credit)?"Subscription ":"") + "Receipt" + _toDisplayString(_ctx.isSubscriptionAdditionalCredits(_ctx.credit)?"(Additional credits)":""), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.appName), 1),
                    _createElementVNode("div", { innerHTML: _ctx.address }, null, 8, _hoisted_11),
                    _hoisted_12,
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_ctx.currentUser.firstName) + " " + _toDisplayString(_ctx.currentUser.lastName), 1),
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(_ctx.currentUser.email), 1),
                      _hoisted_14,
                      _createTextVNode(" " + _toDisplayString(_ctx.currentUser.phone), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _hoisted_16,
                      _createTextVNode(" " + _toDisplayString(_ctx.$filters.dateDisplay(
                      _ctx.credit.updatedTime,
                      "MM/DD/YYYY hh:mm A"
                    )), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_17,
                      _createTextVNode(" Receipt-" + _toDisplayString(_ctx.credit.id), 1)
                    ])
                  ])
                ]),
                _createElementVNode("table", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_20,
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.$filters.numberDisplay(_ctx.credit.credits)), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$filters.numberDisplay(_ctx.credit.amount, 0, 0, "$")), 1)
                    ])
                  ]),
                  _createElementVNode("tfoot", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_23, [
                        _createElementVNode("strong", null, "Total (USD): " + _toDisplayString(_ctx.$filters.numberDisplay(_ctx.credit.amount, 0, 0, "$")), 1)
                      ])
                    ])
                  ])
                ]),
                _hoisted_24
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              class: "btn display--inline-block",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printWindow && _ctx.printWindow(...args)))
            }, " Print "),
            _createElementVNode("button", {
              class: "btn display--inline-block ma--left-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args)))
            }, " Download ")
          ])
        ])
      ])
    ])
  ]))
}